/**
 * Lee el texto/color personalizado de un paso del formulario de reporte
 * (HU-026) desde `configuracion.reporte_textos`, con respaldo en el texto por
 * defecto del componente. Estructura guardada en el backend:
 *   { "<paso>": { "titulo": "", "subtitulo": "", "color": "" } }
 */
export const textoPaso = (configuracion, clave, porDefecto) => {
  const p = (configuracion?.reporte_textos || {})[clave] || {};
  return {
    titulo: p.titulo || porDefecto.titulo,
    subtitulo: p.subtitulo || porDefecto.subtitulo,
    color: p.color || '',
    estilo: p.color ? { color: p.color } : undefined,
  };
};
